// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__8r38R","skybutton":"button_skybutton__H7mFJ"};